// Tax work: Setup / Spain filings. Moved out of CaseBriefPage.js (ticket 072); the
// "Unconfirmed:" line is relabelled by the caller through `unconfirmedLabel`.
import React from 'react'
import { BriefSection, FactGroup, FindingsTable } from './BriefParts'

export function TaxWorkSection({ setupTasks, spainFindings, unconfirmedFacts, unconfirmedLabel = 'Unconfirmed:', notComputedNote = null }) {
  return (
    <BriefSection title="Tax work">
      {notComputedNote ? <p className="brief-empty-note">{notComputedNote}</p> : <>
      {setupTasks.length > 0 && (
        <FactGroup title="Setup" facts={setupTasks} />
      )}

      <div className="brief-fact-group-title brief-tax-work-subheading">Spain filings</div>
      <FindingsTable findings={spainFindings} />
      {unconfirmedFacts.length > 0 && (
        <div className="brief-tax-work-note">
          {unconfirmedLabel} {unconfirmedFacts.map(g => g.label).join(', ')}
        </div>
      )}
      </>}
    </BriefSection>
  )
}
